<template>
  <b-modal
      centered
      modal-class="unit_modal lbl_min_layout"
      v-model="open"
      id="modal-confirm"
      ref="modal-confirm"
      :title="this.$store.state.modal_confirm.title"
      :ok-title="this.$store.state.modal_confirm.ok_txt"
      :cancel-title="this.$store.state.modal_confirm.cancel_txt"
      @ok="handleOk"
      @close="closeModal"


  >
    <div class="desc_block"><p>{{ this.$store.state.modal_confirm.desc }}</p></div>
  </b-modal>
</template>

<script>

export default {
  components: {},
  name: "modal-confirm",
  data() {
    return {
      open: false
    }
  },
  watch: {

  },
  methods: {
    handleOk(){
      if(this.$store.state.modal_confirm.ok_emit.trim()){
        this.$bus.$emit(this.$store.state.modal_confirm.ok_emit, this.$store.state.modal_confirm.data)
      }
      this.$store.commit('closeModalConfirm');
    },
    closeModal() {
      if(this.$store.state.modal_confirm.cancel_emit.trim()){
        this.$bus.$emit(this.$store.state.modal_confirm.cancel_emit, this.$store.state.modal_confirm.data)
      }
      this.$store.commit('closeModalConfirm');
    }
  },
  mounted() {
    this.$store.subscribe(({type, payload}) => {
      if (type === 'openModalConfirm') this.open = true;
    })
  },
}
</script>

<style scoped>
  .desc_block {color: var(--System-Text);}
  .desc_block > p {font-weight: 400; font-size: 14px; line-height: 16px; margin-bottom: 0;}
</style>
